module.exports = require("@mui/material/Snackbar");